<template>
  <grid
    ref="grid"
    :add-checkmarks="true"
    :list-url="listUrl"
    :show-header="true"
    loading-message="Loading participants ..."
    @header-action="onGridHeaderAction"
  />
</template>

<script lang="ts" setup>
import {useTemplateRef} from 'vue'
import axios from 'axios'
import Rails from '@rails/ujs'

import Grid from './grid.vue'
import {isNonEmptyString} from '../js-utils'
import type {ButtonAction, GridHeaderAction} from './types'

defineProps({
  listUrl: {default: null, type: String}
})

const grid = useTemplateRef<InstanceType<typeof Grid>>('grid')

const onGridHeaderAction = (actionOrName: string | GridHeaderAction | ButtonAction, url?: string): void => {
  if (typeof actionOrName !== 'string' || url === undefined) {
    return
  }

  const name = actionOrName
  if (name === 'import') {
    const selectedParticipantIds = grid.value?.selectedItemIds
    if (!selectedParticipantIds || selectedParticipantIds.length === 0) {
      alert('Please select at least one participant')
      return
    }

    grid.value?.showLoadingIndicator()

    axios.post(url, {
      participant_ids: selectedParticipantIds
    }, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': Rails.csrfToken()
      }
    })
      .then((response) => {
        grid.value?.hideLoadingIndicator()
        if (response.data && isNonEmptyString(response.data.message)) {
          grid.value?.showMessage(response.data.message)
        } else if (response.data && isNonEmptyString(response.data.error)) {
          grid.value?.showError(response.data.error)
        }
      })
      .catch((error) => {
        grid.value?.showError(error.message)
        grid.value?.hideLoadingIndicator()
      })
  }
}
</script>
